import { render, staticRenderFns } from "./process-data-mb.vue?vue&type=template&id=0a7962f3&"
import script from "./process-data-mb.vue?vue&type=script&lang=js&"
export * from "./process-data-mb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports